import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  version: 0,
  examiner: "",
  marks: {},
  work: {},
  choices: {},
  annotations: {}, // Backend returns Object {"1": [...]}
  status: "draft",
  isDirty: false,
};

const osmSlice = createSlice({
  name: "osm",
  initialState,
  reducers: {
    loadDocument: (state, action) => {
      // Load backend data
      const d = action.payload;
      state.version = d.version;
      state.examiner = d.examiner || "";
      state.marks = d.marks || {};
      state.work = d.work || {};
      state.choices = d.choices || {};
      state.annotations = d.annotations || {};
      state.status = d.status || "draft";
      state.isDirty = false;
    },
    setMark: (state, action) => {
      const { partId, mark, work } = action.payload;
      state.marks[partId] = mark;
      if (work !== undefined) state.work[partId] = work;
      state.isDirty = true;
    },
    setChoice: (state, action) => {
      const { questionId, choice } = action.payload;
      state.choices[questionId] = choice;
      state.isDirty = true;
    },
    addAnnotation: (state, action) => {
      const ann = action.payload;
      const pageKey = String(ann.page); // Backend expects string keys like "1"
      if (!state.annotations[pageKey]) state.annotations[pageKey] = [];
      state.annotations[pageKey].push(ann);
      state.isDirty = true;
    },
    removeAnnotation: (state, action) => {
      const id = action.payload;
      Object.values(state.annotations).forEach((list) => {
        const index = list.findIndex((ann) => ann.id === id);
        if (index !== -1) list.splice(index, 1);
      });
      state.isDirty = true;
    },
    updateAnnotation: (state, action) => {
      const { id, changes } = action.payload;
      Object.values(state.annotations).forEach((list) => {
        const ann = list.find((item) => item.id === id);
        if (ann) Object.assign(ann, changes);
      });
      state.isDirty = true;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
      state.isDirty = false;
    },
    setVersion: (state, action) => {
      state.version = action.payload;
    },
  },
});

export const {
  loadDocument,
  setMark,
  setChoice,
  addAnnotation,
  removeAnnotation,
  updateAnnotation,
  setStatus,
  setVersion,
} = osmSlice.actions;
export default osmSlice.reducer;
